import React, { useState, useEffect } from 'react';
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import { Breakpoints } from "@pb/utils/constants/breakpoints";
import { default as useMediaQuery } from "@pb/utils/reactHooks/useMediaQuery";
import { currentBrand } from "@pb/utils/brandConfig";
import { isMonkiBrand } from "@pb/utils/brandConfig";
import cn from 'classnames';
import ChevronDownIcon from "../../../../ui/Icon/HmIcons/ChevronDownIcon";
import ChevronUpIcon from "../../../../ui/Icon/HmIcons/ChevronUpIcon";
import BodyText from "../../../../ui/Typography/texts/BodyText";
import styles from './Selector.module.scss';
const getListOfItems = (array, func, isPbNotifyIfBack) => {
    const returnList = array &&
        array.map((a) => (React.createElement("li", { "data-code": a.value, key: a.value, className: styles.listItem },
            React.createElement("button", { className: styles.listButton, type: "button", onClick: () => func(a.value) }, isPbNotifyIfBack ? React.createElement(BodyText, { Tag: "span" }, a.label) : a.label))));
    return returnList;
};
const Selector = ({ items, label, onSizePick, isPbNotifyIfBack }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isActiveVariant, setIsActiveVariant] = useState('');
    useEffect(() => {
        const findactivevar = () => {
            var _a, _b, _c, _d;
            const getActiveItem = items &&
                items.find((i) => {
                    return i.isActive && i.isActive === true;
                });
            const defaultString = isPbNotifyIfBack
                ? getLabelFromStorage('notifyIfBack.modal.select.selectSize')
                : (_d = (_c = (_b = (_a = hm === null || hm === void 0 ? void 0 : hm.i18n) === null || _a === void 0 ? void 0 : _a.notifyIfBack) === null || _b === void 0 ? void 0 : _b.modal) === null || _c === void 0 ? void 0 : _c.select) === null || _d === void 0 ? void 0 : _d.selectSize;
            return (getActiveItem === null || getActiveItem === void 0 ? void 0 : getActiveItem.label) || defaultString || '';
        };
        if (findactivevar) {
            setIsActiveVariant(findactivevar);
        }
    }, [items]);
    const onVariantClick = (code) => {
        setIsOpen(!isOpen);
        if (code && onSizePick) {
            onSizePick(code);
        }
    };
    const isXSmallScreen = useMediaQuery(Breakpoints.XSMALL);
    const isSmallScreen = useMediaQuery(Breakpoints.SMALL);
    const isMediumScreen = useMediaQuery(Breakpoints.MEDIUM);
    return (React.createElement("div", { className: styles.listWrapper },
        React.createElement("button", { type: "button", className: styles.selectTrigger, onClick: () => setIsOpen(!isOpen), tabIndex: 0 },
            isPbNotifyIfBack ? React.createElement(BodyText, { Tag: "span" }, isActiveVariant) : isActiveVariant,
            React.createElement(ChevronDownIcon, { className: styles.icon })),
        React.createElement("ul", { className: cn(styles.listContainer, styles[`${currentBrand}`], isOpen && styles.isOpen) },
            React.createElement("li", { key: "listLabel", className: styles.listItem },
                React.createElement("button", { className: cn(styles.listButton, {
                        [styles.hideOnMobile]: !isMonkiBrand &&
                            isPbNotifyIfBack &&
                            (isXSmallScreen || isSmallScreen || isMediumScreen),
                    }), type: "button", onClick: () => setIsOpen(!isOpen) },
                    label,
                    isPbNotifyIfBack ? (React.createElement(ChevronDownIcon, { className: cn(styles.icon, styles.rotate) })) : (React.createElement(ChevronUpIcon, { className: styles.icon })))),
            getListOfItems(items, onVariantClick, isPbNotifyIfBack)),
        React.createElement("div", { className: cn(styles.overlay, { [styles.overlayIsOpen]: isOpen && !isPbNotifyIfBack }), role: "presentation", onClick: () => setIsOpen(false) })));
};
export default React.memo(Selector);
//# sourceMappingURL=Selector.js.map